import { memo } from "react";
import { pick } from "@/lib/format";
import { imgSrc } from "@/lib/media";
import { MenuCard } from "./MenuCard";

export const MenuSection = memo(function MenuSection({ category, items, s, lang, t, onOpen }) {
  const name = pick(category, "name", lang);
  const desc = pick(category, "description", lang);
  return (
    <section id={`sec-${category.id}`} data-testid={`menu-section-${category.id}`} style={{ paddingTop: "calc(var(--wt-gap) * 2)" }}>
      <div data-anchor={`cat-${category.id}`} className="mb-4 flex items-center gap-3">
        {category.image_url && <img src={imgSrc(category.image_url, "sm")} alt="" loading="lazy" className="h-11 w-11 shrink-0 rounded-full object-cover" />}
        <div className="min-w-0">
          <h2 lang={name.lang} className="break-words text-lg font-extrabold tracking-tight sm:text-xl" data-testid={`menu-section-title-${category.id}`}>{name.text}</h2>
          {s.menu.show_category_desc && desc.text && <p lang={desc.lang} className="text-sm text-[var(--wt-muted)]">{desc.text}</p>}
        </div>
        <span aria-hidden className="mx-1 h-px flex-1" style={{ background: "color-mix(in srgb, var(--wt-text) 10%, transparent)" }} />
        <span className="shrink-0 text-xs font-semibold tabular-nums" style={{ color: "var(--wt-primary)" }}>{items.length}</span>
      </div>
      <div className="wt-grid">
        {items.map((i) => (
          <MenuCard key={i.id} item={i} s={s} lang={lang} t={t} onOpen={onOpen} />
        ))}
      </div>
    </section>
  );
});
